import axios from 'axios';

const ApiKeysAPI = {
  /**
   * Get API keys for an organization
   * @param {number} organizationId - Organization ID
   * @param {Object} params - Query parameters (page, limit, search)
   * @returns {Promise}
   */
  getApiKeys(organizationId, params = {}) {
    return axios.get(`/organizations/${organizationId}/api-keys`, {
      params,
    });
  },

  /**
   * Create a new API key for an organization
   * @param {number} organizationId - Organization ID
   * @param {Object} data - API key data (name, description)
   * @returns {Promise}
   */
  createApiKey(organizationId, data) {
    return axios.post(`/organizations/${organizationId}/api-keys`, data);
  },

  /**
   * Get a specific API key
   * @param {number} organizationId - Organization ID
   * @param {number} apiKeyId - API Key ID
   * @returns {Promise}
   */
  getApiKey(organizationId, apiKeyId) {
    return axios.get(`/organizations/${organizationId}/api-keys/${apiKeyId}`);
  },

  /**
   * Update an API key
   * @param {number} organizationId - Organization ID
   * @param {number} apiKeyId - API Key ID
   * @param {Object} data - Updated API key data
   * @returns {Promise}
   */
  updateApiKey(organizationId, apiKeyId, data) {
    return axios.post(
      `/organizations/${organizationId}/api-keys/${apiKeyId}`,
      data
    );
  },

  /**
   * Delete an API key
   * @param {number} organizationId - Organization ID
   * @param {number} apiKeyId - API Key ID
   * @returns {Promise}
   */
  deleteApiKey(organizationId, apiKeyId) {
    return axios.delete(
      `/organizations/${organizationId}/api-keys/${apiKeyId}`
    );
  },
};

export default ApiKeysAPI;
